/** Priority order for resolving chapter prose from inline or Storage records. */
export const CHAPTER_PROSE_FIELD_PRIORITY = [
  'finalText',
  'content',
  'text',
  'chapterText',
  'draftText',
] as const;

export type ChapterProseField = (typeof CHAPTER_PROSE_FIELD_PRIORITY)[number];

/**
 * Returns the first non-empty prose string from a chapter or Storage JSON object.
 */
export function resolveChapterProseText(
  source: Record<string, unknown> | null | undefined,
): string {
  if (!source || typeof source !== 'object') return '';
  for (const field of CHAPTER_PROSE_FIELD_PRIORITY) {
    const value = source[field];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }
  return '';
}
